import { DeviceMap } from 'components/data/DeviceMap/DeviceMap';
import styles from './Map.module.scss';

export function Map() {
    return (
        <div data-testid="Map" className={styles.container}>
            <DeviceMap />
        </div>
    );
}
